import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { describeReferralFailure, tidyPracticeCode } from '../../../../core/models/referral.model';
import { ReferralService } from '../../../../core/services/referral.service';

export interface ReferralPracticeLinkDialogResult {
  requested: boolean;
  alreadyInNetwork?: boolean;
  acceptedTheirRequest?: boolean;
  /** They had asked us, and only our practice owner may accept: it waits in the owner's Inbox (owner, 2026-09-22). */
  awaitingOwner?: boolean;
}

/**
 * Link with another MedicAI practice by its referral code (referrals architecture §19, P2, P3). The code comes from that
 * practice's administrators; one of them then accepts the request.
 */
@Component({
  selector: 'app-referral-practice-link-dialog',
  templateUrl: './referral-practice-link-dialog.component.html',
  styleUrls: ['../referral-invite-dialog/referral-invite-dialog.component.scss'],
})
export class ReferralPracticeLinkDialogComponent {
  code = '';
  isSaving = false;
  error: string | null = null;

  constructor(
    private referralService: ReferralService,
    private dialogRef: MatDialogRef<ReferralPracticeLinkDialogComponent, ReferralPracticeLinkDialogResult>,
  ) {}

  get canSubmit(): boolean {
    return !this.isSaving && tidyPracticeCode(this.code).complete;
  }

  onInput(value: string): void {
    this.code = tidyPracticeCode(value).code;
    this.error = null;
  }

  submit(): void {
    if (!this.canSubmit) return;
    this.isSaving = true;
    this.error = null;
    this.referralService.requestPracticeLink(this.code).subscribe({
      next: (result) => this.dialogRef.close({ requested: true, alreadyInNetwork: result.alreadyInNetwork, acceptedTheirRequest: result.acceptedTheirRequest, awaitingOwner: result.awaitingOwner }),
      error: (error) => {
        this.isSaving = false;
        this.error = describeReferralFailure(error, 'The request could not be sent. Please try again.');
      },
    });
  }

  cancel(): void {
    this.dialogRef.close({ requested: false });
  }
}
